module.exports = __webpack_public_path__ + "media/images/front/icon_twitter-62cdb361614efc453e62d8529e3c8bed.png";